module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-navigation"
  }, [_c('button', {
    staticClass: "nav-button",
    on: {
      "click": function($event) {
        return _vm.navigate('previous')
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15.75 19.5L8.25 12l7.5-7.5"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "nav-button center-button",
    on: {
      "click": _vm.goToToday
    }
  }, [_vm._v("I dag")]), _vm._v(" "), _c('button', {
    staticClass: "nav-button",
    on: {
      "click": function($event) {
        return _vm.navigate('next')
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M8.25 4.5l7.5 7.5-7.5 7.5"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77923726!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/BottomNav.vue
// module id = 2018
// module chunks = 1